 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"static/js/chunks/Acd":"static/js/chunks/Acd","static/js/chunks/AgentList~static/js/chunks/Calling~static/js/chunks/Dashboard~static/js/chunks/EndC~e3a60f86":"static/js/chunks/AgentList~static/js/chunks/Calling~static/js/chunks/Dashboard~static/js/chunks/EndC~e3a60f86","static/js/chunks/AgentList~static/js/chunks/Calling~static/js/chunks/Dashboard~static/js/chunks/EndC~655dd60d":"static/js/chunks/AgentList~static/js/chunks/Calling~static/js/chunks/Dashboard~static/js/chunks/EndC~655dd60d","static/js/chunks/AgentList":"static/js/chunks/AgentList","static/js/chunks/Calling":"static/js/chunks/Calling","static/js/chunks/Dashboard~static/js/chunks/absenceResponse":"static/js/chunks/Dashboard~static/js/chunks/absenceResponse","static/js/chunks/Dashboard":"static/js/chunks/Dashboard","static/js/chunks/absenceResponse":"static/js/chunks/absenceResponse","static/js/chunks/EndCall":"static/js/chunks/EndCall","static/js/chunks/EndCallSecondary":"static/js/chunks/EndCallSecondary","static/js/chunks/ListPhoneAccount":"static/js/chunks/ListPhoneAccount","static/js/chunks/Monitoring/index":"static/js/chunks/Monitoring/index","static/js/chunks/callMonitoring":"static/js/chunks/callMonitoring","static/js/chunks/chatMessage/ACastChat~static/js/chunks/lineChat/index":"static/js/chunks/chatMessage/ACastChat~static/js/chunks/lineChat/index","static/js/chunks/lineChat/index":"static/js/chunks/lineChat/index","static/js/chunks/companySetting":"static/js/chunks/companySetting","static/js/chunks/twilioPhoneNumber":"static/js/chunks/twilioPhoneNumber","static/js/chunks/CallList":"static/js/chunks/CallList","static/js/chunks/ChangePassword":"static/js/chunks/ChangePassword","static/js/chunks/ForgotPassword":"static/js/chunks/ForgotPassword","static/js/chunks/Login":"static/js/chunks/Login","static/js/chunks/ResetPassword":"static/js/chunks/ResetPassword","static/js/chunks/TwilioSetting":"static/js/chunks/TwilioSetting","static/js/chunks/TwilioSetup":"static/js/chunks/TwilioSetup","static/js/chunks/callOut":"static/js/chunks/callOut","static/js/chunks/chatMessage/Chat":"static/js/chunks/chatMessage/Chat","static/js/chunks/manageEndCallStatus":"static/js/chunks/manageEndCallStatus","static/js/chunks/chatMessage/ACastChat":"static/js/chunks/chatMessage/ACastChat","static/js/chunks/chatMessage/OtherChat":"static/js/chunks/chatMessage/OtherChat"}[chunkId]||chunkId) + "." + {"chunk-17f8f2a8":"31e2e0a1","static/js/chunks/Acd":"486ead1a","static/js/chunks/AgentList~static/js/chunks/Calling~static/js/chunks/Dashboard~static/js/chunks/EndC~e3a60f86":"0416a526","static/js/chunks/AgentList~static/js/chunks/Calling~static/js/chunks/Dashboard~static/js/chunks/EndC~655dd60d":"3ace151c","static/js/chunks/AgentList":"f3d45dfb","static/js/chunks/Calling":"44ece583","static/js/chunks/Dashboard~static/js/chunks/absenceResponse":"8f08324d","static/js/chunks/Dashboard":"90ce6300","static/js/chunks/absenceResponse":"bdb6918c","static/js/chunks/EndCall":"b567e486","static/js/chunks/EndCallSecondary":"92cc5889","static/js/chunks/ListPhoneAccount":"754e2b26","static/js/chunks/Monitoring/index":"f3d27932","static/js/chunks/callMonitoring":"7fdfa266","static/js/chunks/chatMessage/ACastChat~static/js/chunks/lineChat/index":"f5ffa35c","static/js/chunks/lineChat/index":"7aac897d","static/js/chunks/companySetting":"e6eda927","static/js/chunks/twilioPhoneNumber":"10fb231d","static/js/chunks/CallList":"37257bcd","static/js/chunks/ChangePassword":"ba2927b4","static/js/chunks/ForgotPassword":"260bd83e","static/js/chunks/Login":"1141e50a","static/js/chunks/ResetPassword":"ef67c9e4","static/js/chunks/TwilioSetting":"2aec1cfe","static/js/chunks/TwilioSetup":"6a115287","static/js/chunks/callOut":"92519257","static/js/chunks/chatMessage/Chat":"ddf46ae6","static/js/chunks/manageEndCallStatus":"6fb880f3","static/js/chunks/chatMessage/ACastChat":"1120f4bc","static/js/chunks/chatMessage/OtherChat":"9706ff9d"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-17f8f2a8":1,"static/js/chunks/Acd":1,"static/js/chunks/AgentList~static/js/chunks/Calling~static/js/chunks/Dashboard~static/js/chunks/EndC~e3a60f86":1,"static/js/chunks/AgentList~static/js/chunks/Calling~static/js/chunks/Dashboard~static/js/chunks/EndC~655dd60d":1,"static/js/chunks/AgentList":1,"static/js/chunks/Calling":1,"static/js/chunks/Dashboard~static/js/chunks/absenceResponse":1,"static/js/chunks/Dashboard":1,"static/js/chunks/absenceResponse":1,"static/js/chunks/EndCall":1,"static/js/chunks/EndCallSecondary":1,"static/js/chunks/ListPhoneAccount":1,"static/js/chunks/Monitoring/index":1,"static/js/chunks/callMonitoring":1,"static/js/chunks/chatMessage/ACastChat~static/js/chunks/lineChat/index":1,"static/js/chunks/lineChat/index":1,"static/js/chunks/companySetting":1,"static/js/chunks/ChangePassword":1,"static/js/chunks/ForgotPassword":1,"static/js/chunks/Login":1,"static/js/chunks/ResetPassword":1,"static/js/chunks/TwilioSetting":1,"static/js/chunks/TwilioSetup":1,"static/js/chunks/manageEndCallStatus":1,"static/js/chunks/chatMessage/ACastChat":1,"static/js/chunks/chatMessage/OtherChat":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"static/js/chunks/Acd":"static/js/chunks/Acd","static/js/chunks/AgentList~static/js/chunks/Calling~static/js/chunks/Dashboard~static/js/chunks/EndC~e3a60f86":"static/js/chunks/AgentList~static/js/chunks/Calling~static/js/chunks/Dashboard~static/js/chunks/EndC~e3a60f86","static/js/chunks/AgentList~static/js/chunks/Calling~static/js/chunks/Dashboard~static/js/chunks/EndC~655dd60d":"static/js/chunks/AgentList~static/js/chunks/Calling~static/js/chunks/Dashboard~static/js/chunks/EndC~655dd60d","static/js/chunks/AgentList":"static/js/chunks/AgentList","static/js/chunks/Calling":"static/js/chunks/Calling","static/js/chunks/Dashboard~static/js/chunks/absenceResponse":"static/js/chunks/Dashboard~static/js/chunks/absenceResponse","static/js/chunks/Dashboard":"static/js/chunks/Dashboard","static/js/chunks/absenceResponse":"static/js/chunks/absenceResponse","static/js/chunks/EndCall":"static/js/chunks/EndCall","static/js/chunks/EndCallSecondary":"static/js/chunks/EndCallSecondary","static/js/chunks/ListPhoneAccount":"static/js/chunks/ListPhoneAccount","static/js/chunks/Monitoring/index":"static/js/chunks/Monitoring/index","static/js/chunks/callMonitoring":"static/js/chunks/callMonitoring","static/js/chunks/chatMessage/ACastChat~static/js/chunks/lineChat/index":"static/js/chunks/chatMessage/ACastChat~static/js/chunks/lineChat/index","static/js/chunks/lineChat/index":"static/js/chunks/lineChat/index","static/js/chunks/companySetting":"static/js/chunks/companySetting","static/js/chunks/twilioPhoneNumber":"static/js/chunks/twilioPhoneNumber","static/js/chunks/CallList":"static/js/chunks/CallList","static/js/chunks/ChangePassword":"static/js/chunks/ChangePassword","static/js/chunks/ForgotPassword":"static/js/chunks/ForgotPassword","static/js/chunks/Login":"static/js/chunks/Login","static/js/chunks/ResetPassword":"static/js/chunks/ResetPassword","static/js/chunks/TwilioSetting":"static/js/chunks/TwilioSetting","static/js/chunks/TwilioSetup":"static/js/chunks/TwilioSetup","static/js/chunks/callOut":"static/js/chunks/callOut","static/js/chunks/chatMessage/Chat":"static/js/chunks/chatMessage/Chat","static/js/chunks/manageEndCallStatus":"static/js/chunks/manageEndCallStatus","static/js/chunks/chatMessage/ACastChat":"static/js/chunks/chatMessage/ACastChat","static/js/chunks/chatMessage/OtherChat":"static/js/chunks/chatMessage/OtherChat"}[chunkId]||chunkId) + "." + {"chunk-17f8f2a8":"98f928f0","static/js/chunks/Acd":"3e21d987","static/js/chunks/AgentList~static/js/chunks/Calling~static/js/chunks/Dashboard~static/js/chunks/EndC~e3a60f86":"2e39fa1c","static/js/chunks/AgentList~static/js/chunks/Calling~static/js/chunks/Dashboard~static/js/chunks/EndC~655dd60d":"06827d2b","static/js/chunks/AgentList":"b8a25933","static/js/chunks/Calling":"497b3549","static/js/chunks/Dashboard~static/js/chunks/absenceResponse":"6c6390d7","static/js/chunks/Dashboard":"92ca1fa5","static/js/chunks/absenceResponse":"aedbe682","static/js/chunks/EndCall":"858aba3d","static/js/chunks/EndCallSecondary":"0180593a","static/js/chunks/ListPhoneAccount":"c2dd027f","static/js/chunks/Monitoring/index":"a9cb4634","static/js/chunks/callMonitoring":"8ee64086","static/js/chunks/chatMessage/ACastChat~static/js/chunks/lineChat/index":"e830ce8b","static/js/chunks/lineChat/index":"5e7ffe50","static/js/chunks/companySetting":"dc3c4b10","static/js/chunks/twilioPhoneNumber":"31d6cfe0","static/js/chunks/CallList":"31d6cfe0","static/js/chunks/ChangePassword":"513bd68a","static/js/chunks/ForgotPassword":"15f38117","static/js/chunks/Login":"aacf3ee8","static/js/chunks/ResetPassword":"49f34b5c","static/js/chunks/TwilioSetting":"67edda0d","static/js/chunks/TwilioSetup":"43fc9a9d","static/js/chunks/callOut":"31d6cfe0","static/js/chunks/chatMessage/Chat":"31d6cfe0","static/js/chunks/manageEndCallStatus":"2b84a174","static/js/chunks/chatMessage/ACastChat":"f0261d6f","static/js/chunks/chatMessage/OtherChat":"d8738c4a"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
